function getTableStorageKey(id) {
  return `quizzes_table_${id}`;
}

export function saveTableState(id, state) {
  try {
    sessionStorage.setItem(getTableStorageKey(id), JSON.stringify(state));
  } catch(e) {}
}

export function getTableState(id) {
  try {
    return JSON.parse(sessionStorage.getItem(getTableStorageKey(id)));
  } catch(e) {
    return null;
  }
}
